<app-page-title [title]="'Affiliate Activity'"></app-page-title>

<div class="row">
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-8">
                <canvas
                    baseChart
                    [datasets]="barChartData"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [legend]="barChartLegend"
                    [chartType]="barChartType"
                ></canvas>
            </div>
            <div class="col-md-4">
                <br /><br />

                <a
                    [routerLink]="['/account/affiliate/link-create']"
                    [queryParams]="{linkcreate: 'true'}"
                    class="btn btn-primary affiliate-btn"
                >Create An Affiliate Link</a>
                <br /><br />
                <a
                    [routerLink]="['/account/affiliate/report']"
                    class="btn btn-primary affiliate-btn "
                >Monthly Report</a>
            </div>
        </div>
        <br /><br />
        <div class="row">
            <div class="col-md-12">
                <em>*</em> Please note, affiliate activity may not be reflected immediately. The "number of purchases" counts completed test sittings as at today's date,
                therefore, if test takers are registered for future tests dates, those numbers will appear following the day of the test.
                If you have any questions please contact <a href="mailto:memberteam@prometric.com">memberteam@prometric.com</a> for support.
            </div>
        </div>
        <br>
        <table class="affiliate">
            <tr>
                <th style="text-align:left">Link</th>
                <th>Delivery Method</th>
                <th># of Clicks</th>
                <th># of Accounts</th>
                <th># of Purchases</th>
                <th># Purchases without Payout</th>
                <th>Currency</th>
                <th>$ Total Purchases</th>
                <th>$ Payout</th>
            </tr>
            <tr *ngIf="summaryData.length == 0 || summaryData == null || summaryData == undefined ">
                <td colspan="9">There are no current records</td>
            </tr>
            <ng-container *ngFor="let data of summaryData">
                <tr>
                    <td style="width:40%; text-align:left">

                        <a
                            [routerLink]="['/account/affiliate/link-detail']"
                            [queryParams]="{linkId: data.id}"
                        >{{data.linkName}}</a>
                        <div class="description">{{data.description}}</div>
                    </td>
                    <td>{{data.deliveryMethod}}</td>
                    <td>{{data.clicks}}</td>
                    <td>{{data.accounts}}</td>
                    <td>{{data.purchases }}</td>
                    <td>{{data.purchasesNumberWithoutPayment}}</td>
                    <td>
                        <div *ngFor="let linkDetail of data.currencyDetail">
                            <div>{{linkDetail.currency}}</div>
                        </div>
                    </td>
                    <td>
                        <div *ngFor="let linkDetail of data.currencyDetail">
                            <div>{{linkDetail.purchaseAmount | currency : "": ""}}</div>
                        </div>
                    </td>
                    <td>
                        <div *ngFor="let linkDetail of data.currencyDetail">
                            <div>{{linkDetail.payout | currency : "":""}}</div>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </table>
    </div>
</div>
